/**
 * @generated SignedSource<<376902d654f03f75c267507e2d87dced>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type PendingIssueSuggestionState = "APPLIED" | "PENDING" | "REJECTED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useRecentAgentActivity_issue$data = {
  readonly id: string;
  readonly pendingSuggestions: ReadonlyArray<{
    readonly __typename: "PendingFieldSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
    } | null | undefined;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly fieldState: PendingIssueSuggestionState;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly issueField: {
      readonly id?: string;
      readonly name?: string;
      readonly options?: ReadonlyArray<{
        readonly color: IssueFieldSingleSelectOptionColor;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly rationale: string | null | undefined;
    readonly suggestedValue: string | null | undefined;
  } | {
    readonly __typename: "PendingLabelSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
    } | null | undefined;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly label: {
      readonly color: string;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly labelState: PendingIssueSuggestionState;
    readonly rationale: string | null | undefined;
  } | {
    readonly __typename: "PendingTypeSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
    } | null | undefined;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly issueType: {
      readonly color: IssueTypeColor;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly rationale: string | null | undefined;
    readonly typeState: PendingIssueSuggestionState;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }> | null | undefined;
  readonly recentTriageEvents: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "IssueFieldAddedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly color: string | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
      readonly value: string | null | undefined;
    } | {
      readonly __typename: "IssueFieldChangedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
      readonly newColor: string | null | undefined;
      readonly newValue: string | null | undefined;
    } | {
      readonly __typename: "IssueFieldRemovedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeAddedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeChangedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeRemovedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "LabeledEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly label: {
        readonly color: string;
        readonly name: string;
      };
    } | {
      readonly __typename: "UnlabeledEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly intent: {
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly intentId: string | null | undefined;
        readonly rationale: string | null | undefined;
      } | null | undefined;
      readonly label: {
        readonly color: string;
        readonly name: string;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly repository: {
    readonly nameWithOwner: string;
  };
  readonly viewerCanUpdateMetadata: boolean | null | undefined;
  readonly " $fragmentType": "useRecentAgentActivity_issue";
};
export type useRecentAgentActivity_issue$key = {
  readonly " $data"?: useRecentAgentActivity_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentAgentActivity_issue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intentId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "type": "Bot",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v0/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rationale",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v12 = [
  (v0/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "IssueFieldCommon",
  "abstractKey": "__isIssueFieldCommon"
},
v14 = [
  (v10/*: any*/),
  (v11/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v8/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v18 = [
  (v0/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Label",
    "kind": "LinkedField",
    "name": "label",
    "plural": false,
    "selections": (v14/*: any*/),
    "storageKey": null
  },
  (v16/*: any*/),
  (v17/*: any*/)
],
v19 = [
  (v0/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueType",
    "kind": "LinkedField",
    "name": "issueType",
    "plural": false,
    "selections": (v14/*: any*/),
    "storageKey": null
  },
  (v16/*: any*/),
  (v17/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v13/*: any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "since"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRecentAgentActivity_issue",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateMetadata",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pendingSuggestions",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "typeState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v3/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": (v12/*: any*/),
              "storageKey": null
            }
          ],
          "type": "PendingTypeSuggestion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "labelState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v3/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Label",
              "kind": "LinkedField",
              "name": "label",
              "plural": false,
              "selections": (v12/*: any*/),
              "storageKey": null
            }
          ],
          "type": "PendingLabelSuggestion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "fieldState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v3/*: any*/),
            (v7/*: any*/),
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "suggestedValue",
              "storageKey": null
            },
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "issueField",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "type": "Node",
                  "abstractKey": "__isNode"
                },
                (v13/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IssueFieldSingleSelectOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": (v14/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFieldSingleSelect",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PendingFieldSuggestion",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "recentTriageEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "itemTypes",
          "value": [
            "LABELED_EVENT",
            "UNLABELED_EVENT",
            "ISSUE_TYPE_ADDED_EVENT",
            "ISSUE_TYPE_CHANGED_EVENT",
            "ISSUE_TYPE_REMOVED_EVENT",
            "ISSUE_FIELD_CHANGED_EVENT",
            "ISSUE_FIELD_ADDED_EVENT",
            "ISSUE_FIELD_REMOVED_EVENT"
          ]
        },
        {
          "kind": "Literal",
          "name": "last",
          "value": 25
        },
        {
          "kind": "Variable",
          "name": "since",
          "variableName": "since"
        },
        {
          "kind": "Literal",
          "name": "visibleEventsOnly",
          "value": true
        }
      ],
      "concreteType": "IssueTimelineItemsConnection",
      "kind": "LinkedField",
      "name": "timelineItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v18/*: any*/),
              "type": "LabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v18/*: any*/),
              "type": "UnlabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v19/*: any*/),
              "type": "IssueTypeAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v19/*: any*/),
              "type": "IssueTypeChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v19/*: any*/),
              "type": "IssueTypeRemovedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v15/*: any*/),
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newValue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newColor",
                  "storageKey": null
                },
                (v16/*: any*/),
                (v17/*: any*/)
              ],
              "type": "IssueFieldChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v15/*: any*/),
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                (v11/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/)
              ],
              "type": "IssueFieldAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v15/*: any*/),
                (v20/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/)
              ],
              "type": "IssueFieldRemovedEvent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "61ddb3332244cd7e5f6af98d1448cd8a";

export default node;
